
<template>
  <div class="labor-assumptions">
    <span class="adjust-section-title section-title hidden-xs-only">
      Adjust the labor assumptions
    </span>
    <span class="adjust-section-title section-title hidden-sm-and-up">
      Labor assumptions
    </span>

    <v-layout row pt-3>
      <value-adjustment
        ident="hourlyRate"
        title="HOURLY RATE"
        :value="hourlyRate"
        prefix="$"
        v-on:value-changed="updateHourlyRate"
      ></value-adjustment>
    </v-layout>

  </div>
</template>

<script>
export default {
  name: 'labor-assumptions',
  data () {
    return {
    }
  },

  methods: {
    updateHourlyRate(ev) {
      let update = this.laborAssumptions
      update.rateAverageLocked = false
      update.hourlyRate = Number(ev.val)
      this.$store.commit('setLaborAssumptions', update)
    },
    resetAssumptionValues() {
      this.$store.commit('setLaborAssumptionsToDefault')
    }
  },

  computed: {
    laborAssumptions() {
      return this.$store.getters.laborAssumptions
    },
    hourlyRate() {
      return this.laborAssumptions.hourlyRate
    },
  },

  components: {
    'range-adjustment': () => import ('@/components/RangeAdjustment'),
    'delta-adjustment': () => import ('@/components/DeltaAdjustment'),
    'value-adjustment': () => import ('@/components/ValueAdjustment'),
  }

}

</script>


<style scoped>
a:hover {
  font-weight: bold;
}

.labor-assumptions {
  height: 100%;
}
.adjust-actions {
  display: inline-block;
  font-size: 10pt;
  position: absolute;
  right: 180px;
  top: 5px;
}
.section-title {
  text-align: left;
  padding-left: 10px;
  color: #444;
}
.adjust-section-title {
  font-weight: bold;
  font-size: 13pt;
}
.vertical-separator {
  width: 1px;
  height: 35px;
  background-color: #ccc;
  position: relative;
  top: 35px;
}


@media only screen and (max-width: 600px) {
  .adjust-actions {
    right: 5px;
  }
}

@media only screen and (max-height: 550px) {
  .adjust-actions {
    right: 5px;
  }
}

</style>